const KILO_BYTE = 1024;
const MEGA_BYTE = KILO_BYTE * KILO_BYTE;

export const MAX_ATTACHMENT_SIZE_MEGABYTES =  25;
export const MAX_ATTACHMENT_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MEGABYTES * MEGA_BYTE;
export const RECOMMENDED_ATTACHMENT_SIZE_MEGABYTES = 10;
